module.exports = __webpack_public_path__ + "img/controller-up.a3f6ece8.svg";